import i18n from 'src/i18n';
export let footerConstantsProduct = {
  linkList: [
    {
      text: i18n.t('learnMore'),
      link: 'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
      target: '_blank',
    },
    {
      text: i18n.t('support'),
      link: '',
    },
    {
      text: i18n.t('contactSales'),
      link: 'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
      target: '_blank',
    }
  ]
};

i18n.on('languageChanged', function () {
  updateTranslations();
});

function updateTranslations() {
  footerConstantsProduct = {
    linkList: [
      {
        text: i18n.t('learnMore'),
        link: 'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
        target: '_blank',
      },
      {
        text: i18n.t('support'),
        link: '',
      },
      {
        text: i18n.t('contactSales'),
        link: 'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
        target: '_blank',
      }
    ]
  };
}
